import { formatMilliseconds, scoresColumnFormatter } from "../../helpers"
import startCase from "lodash/startCase"
import { FILTER_OPTIONS } from "../filters"
import { TableData } from "./types"
import {
  reportingCategoriesAndStandardsFormatter,
  shownSkillsFormatter
} from "../../helpers/tables/content"

export const CONTENT_LIBRARY: TableData = {
  // Dynamic columns are generated in helpers/tables.ts
  columns: [
    {
      label: "Name",
      name: "content_view_list.name",
      sortable: true,
      description: "content_view_list.description"
    },
    {
      label: "Test",
      name: "content_view_list.test",
      sortable: true
    },
    {
      label: "Type",
      name: "content_view_list.type",
      sortable: true,
      // Hide "type" column if exactly one type is selected.
      filter: filters => filters.contentType?.length !== 1,
      formatter: (record: any, prop: string) =>
        FILTER_OPTIONS.contentType.find(option => option.value === record[prop])
          ?.label ?? startCase(record[prop])
    },
    {
      label: "Standard",
      name: "content_view_list.standards",
      sortable: true,
      formatter: reportingCategoriesAndStandardsFormatter
    },
    {
      label: "Reporting Category",
      name: "content_view_list.nodeNames",
      sortable: true,
      formatter: reportingCategoriesAndStandardsFormatter
    },
    {
      label: "Duration",
      name: "content_view_list.duration",
      sortable: true,
      type: "duration",
      align: "right"
    }
    /*
      From here and below: "% Assigned" and "% Completed" metrics are postponed 
      for all content except Practice Tests until Assignment Tool is done.
      See https://bam-boo.atlassian.net/browse/MRM-647.
    */
    // {
    //   label: "% Assigned",
    //   name: "content_view_list.assignedPercent",
    //   sortable: true,
    //   type: "percent",
    //   align: "right"
    // },
    // {
    //   label: "% Complete",
    //   name: "content_view_list.completedPercent",
    //   sortable: true,
    //   type: "percent",
    //   align: "right"
    // },
    // REVIEW: No such metric so far.
    // {
    //   label: "Average Time Spent",
    //   name: "",
    //   sortable: true,
    //   type: "duration",
    //   formatter: formatMilliseconds
    // },
    // {
    //   label: "Average Score",
    //   name: "content_view_list.avgScore",
    //   sortable: true,
    //   type: "number",
    //   formatter: (record, prop) =>
    //     record[prop] ? Number(record[prop]).toFixed(2) : record[prop],
    //   align: "right"
    // }
  ],
  displayedProperties: [
    "content_view_list.name",
    "content_view_list.description",
    "content_view_list.type",
    "content_view_list.programDisplayName",
    "content_view_list.test",
    "content_view_list.subject",
    "content_view_list.standards",
    "content_view_list.standardsFilter",
    "content_view_list.standardTreeNames",
    "content_view_list.duration",
    "content_view_list.nodeNames"
    // "content_view_list.completedPercent",
    // "content_view_list.assignedPercent",
    // "content_view_list.avgScore"
  ],
  requestParams: {
    dimensions: [
      "content_view_list.id",
      "content_view_list.name",
      "content_view_list.description",
      "content_view_list.type",
      "content_view_list.programDisplayName",
      "content_view_list.test",
      "content_view_list.subject",
      "content_view_list.nodeNames",
      "content_view_list.standards",
      "content_view_list.standardsFilter",
      "content_view_list.standardTreeNames",
      "content_view_list.duration"
    ],
    measures: [
      // "content_view_list.completedPercent",
      // "content_view_list.assignedPercent",
      "content_view_list.avgScore"
    ]
  },
  requestFilterMap: {
    "content_view_subtests.id": "content_view_list.id",
    "content_view_list.id": "content_view_list.id",
    "content.type": "content_view_list.type",
    "content.skill": "content_view_list.skillsTreeIds",
    "content.standard": "content_view_list.standardsFilter",
    "tests.program": "content_view_list.program",
    "tests.subject": "content_view_list.subject"
  },
  searchRequestParams: ["content_view_list.name"],
  requestDefaultOrder: { "content_view_list.id": "asc" },
  tableOptions: {
    searchPlaceholder: "Content",
    selectable: false,
    pageName: "Content",
    caption: "List of available content items"
  },
  alertPageTitle: "Content"
}

export const CONTENT_LIBRARY_ELEMENT: TableData = {
  columns: [
    {
      label: "Name",
      name: "content_view_br_lessons.name",
      sortable: true,
      description: "content_view_br_lessons.description"
    },
    {
      label: "Test",
      name: "content_view_br_lessons.test",
      sortable: true
    },
    {
      label: "Standard",
      name: "content_view_br_lessons.standards",
      sortable: true,
      formatter: reportingCategoriesAndStandardsFormatter
    },
    {
      label: "Reporting Category",
      name: "content_view_br_lessons.nodeNames",
      sortable: true,
      formatter: reportingCategoriesAndStandardsFormatter
    },
    {
      label: "Duration",
      name: "content_view_br_lessons.duration",
      // sortable: true,
      // type: "duration",
      formatter: (_record, _prop) => {
        // Non-breaking space - looks empty but bypasses the "|| --" fallback
        return "\u00A0"
      },
      align: "right"
    }
    //{
    //   label: "% Complete",
    //   name: "content_view_br_lessons.completedPercent",
    //   sortable: true,
    //   type: "percent",
    //   align: "right"
    // },
    // {
    //  label: "Average Time Spent",
    //  name: "content_view_br_lessons.averageTimeSpent",
    //  // sortable: true,
    //  // type: "duration",
    //  formatter: (record, prop) => {
    //    // Non-breaking space - looks empty but bypasses the "|| --" fallback
    //    return "\u00A0"
    //  },
    //  align: "right"
    //}
  ],
  displayedProperties: [
    "content_view_br_lessons.name",
    "content_view_br_lessons.description",
    "content_view_br_lessons.test",
    "content_view_br_lessons.programDisplayName",
    "content_view_br_lessons.subject",
    "content_view_br_lessons.standards",
    "content_view_br_lessons.standardsFilter",
    "content_view_br_lessons.standardTreeNames",
    "content_view_br_lessons.nodeNames",
    "content_view_br_lessons.duration"
    // "content_view_br_lessons.completedPercent",
    //"content_view_br_lessons.averageTimeSpent"
  ],
  requestParams: {
    dimensions: [
      "content_view_br_lessons.id",
      "content_view_br_lessons.name",
      "content_view_br_lessons.description",
      "content_view_br_lessons.test",
      "content_view_br_lessons.programDisplayName",
      "content_view_br_lessons.subject",
      "content_view_br_lessons.standards",
      "content_view_br_lessons.standardsFilter",
      "content_view_br_lessons.standardTreeNames",
      "content_view_br_lessons.nodeNames",
      "content_view_br_lessons.duration"
      //"content_view_br_lessons.averageTimeSpent"
    ]
    // measures: ["content_view_br_lessons.completedPercent"]
  },
  requestFilterMap: {
    "tests.program": "content_view_br_lessons.program",
    "tests.subject": "content_view_br_lessons.subject",
    "content.standard": "content_view_br_lessons.standardsFilter"
  },
  searchRequestParams: ["content_view_br_lessons.name"],
  requestDefaultOrder: { "content_view_br_lessons.id": "asc" },
  tableOptions: {
    searchPlaceholder: "Content",
    selectable: false,
    caption: "List of Bell Ringer items"
  },
  alertPageTitle: "Content"
}

export const CONTENT_LIBRARY_STUDY_HALL: TableData = {
  columns: [
    {
      label: "Name",
      name: "content_view_sh_lessons.name",
      sortable: true,
      description: "content_view_sh_lessons.description"
    },
    {
      label: "Test",
      name: "content_view_sh_lessons.test",
      sortable: true
    },
    {
      label: "Standard",
      name: "content_view_sh_lessons.standards",
      sortable: true,
      formatter: reportingCategoriesAndStandardsFormatter
    },
    {
      label: "Reporting Category",
      name: "content_view_sh_lessons.nodeNames",
      sortable: true,
      formatter: reportingCategoriesAndStandardsFormatter
    },
    {
      label: "Skills",
      name: "shownSkills",
      sortable: false,
      formatter: shownSkillsFormatter("remainingSkills")
    },
    {
      label: "Duration",
      name: "content_view_sh_lessons.duration",
      sortable: true,
      type: "duration",
      align: "right"
    }
    // {
    //   label: "% Assigned",
    //   name: "content_view_sh_lessons.assignedPercent",
    //   sortable: true,
    //   type: "percent",
    //   align: "right"
    // },
    // {
    //   label: "% Complete",
    //   name: "content_view_sh_lessons.completedPercent",
    //   sortable: true,
    //   type: "percent",
    //   align: "right"
    // },
    //{
    //  label: "Average Time Spent",
    //  name: "content_view_sh_lessons.averageTimeSpent",
    //  sortable: true,
    //  type: "duration",
    //  formatter: formatMilliseconds,
    //  align: "right"
    //}
    // {
    //   label: "Average Accuracy",
    //   name: "content_view_sh_lessons.accuracy",
    //   sortable: true,
    //   type: "percent",
    //   formatter: (record, prop) =>
    //     Number(record["content_view_sh_lessons.attempts"])
    //       ? Math.round(record[prop])
    //       : "--",
    //   align: "right"
    // }
  ],
  displayedProperties: [
    "content_view_sh_lessons.name",
    "content_view_sh_lessons.description",
    "content_view_sh_lessons.test",
    "content_view_sh_lessons.programDisplayName",
    "content_view_sh_lessons.subject",
    "content_view_sh_lessons.standards",
    "content_view_sh_lessons.nodeNames",
    "shownSkills",
    "content_view_sh_lessons.duration",
    "content_view_sh_lessons.averageTimeSpent",
    // "content_view_sh_lessons.assignedPercent",
    // "content_view_sh_lessons.completedPercent",
    // "content_view_sh_lessons.accuracy",
    "content_view_sh_lessons.attempts"
  ],
  requestParams: {
    dimensions: [
      "content_view_sh_lessons.id",
      "content_view_sh_lessons.name",
      "content_view_sh_lessons.description",
      "content_view_sh_lessons.programDisplayName",
      "content_view_sh_lessons.test",
      "content_view_sh_lessons.subject",
      "content_view_sh_lessons.standards",
      "content_view_sh_lessons.nodeNames",
      "content_view_sh_lessons.duration",
      "content_view_sh_lessons.averageTimeSpent"
    ],
    measures: [
      // "content_view_sh_lessons.assignedPercent",
      // "content_view_sh_lessons.completedPercent",
      // "content_view_sh_lessons.accuracy",
      "content_view_sh_lessons.attempts"
    ]
  },
  requestFilterMap: {
    "tests.program": "content_view_sh_lessons.program",
    "tests.subject": "content_view_sh_lessons.subject",
    "content.standard": "content_view_sh_lessons.standardsFilter"
  },
  searchRequestParams: ["content_view_sh_lessons.name"],
  requestDefaultOrder: { "content_view_sh_lessons.id": "asc" },
  tableOptions: {
    searchPlaceholder: "Content",
    selectable: false,
    caption: "List of Skill Review items"
  },
  alertPageTitle: "Content"
}

export const CONTENT_LIBRARY_PRACTICE_TEST: TableData = {
  columns: [
    {
      label: "Name",
      name: "content_view_tests.name",
      sortable: true
    },
    {
      label: "Test",
      name: "content_view_tests.test",
      sortable: true
    },
    {
      label: "Skills",
      name: "shownSkills",
      sortable: false,
      formatter: shownSkillsFormatter("remainingSkills")
    },
    {
      label: "Reporting Category",
      name: "content_view_tests.nodeNames",
      sortable: true,
      formatter: reportingCategoriesAndStandardsFormatter
    }
    // {
    //   label: "% Assigned",
    //   name: "content_view_tests.assignedPercent",
    //   sortable: true,
    //   type: "percent",
    //   align: "right"
    // },
    // {
    //   label: "% Complete",
    //   name: "content_view_tests.completedPercent",
    //   sortable: true,
    //   type: "percent",
    //   align: "right"
    // },
    /*
    {
      label: "Average Time Spent",
      name: "content_view_tests.averageTimeSpent",
      sortable: true,
      type: "duration",
      formatter: formatMilliseconds,
      align: "right"
    },
    {
      label: "Average Score",
      name: "content_view_tests.avgScore",
      sortable: true,
      type: "number",
      formatter: (record, prop, context) => {
        const isDiagnostic = record["content_view_tests.name"]
          ?.toLowerCase()
          ?.includes("diagnostic")

        if (record["content_view_tests.program"] === "EACT" && isDiagnostic) {
          return scoresColumnFormatter(
            record["content_view_tests.program"],
            null,
            isDiagnostic,
            record[prop],
            context
          )
        }

        return record[prop] ? Number(record[prop]).toFixed(2) : record[prop]
      },
      align: "right"
    }
    */
  ],
  displayedProperties: [
    "content_view_tests.name",
    "content_view_tests.programDisplayName",
    "content_view_tests.test",
    "content_view_tests.program",
    "content_view_tests.nodeNames",
    "content_view_tests.averageTimeSpent",
    "shownSkills",
    // "content_view_tests.assignedPercent",
    // "content_view_tests.completedPercent",
    "content_view_tests.avgScore"
  ],
  requestParams: {
    dimensions: [
      "content_view_tests.id",
      "content_view_tests.name",
      "content_view_tests.test",
      "content_view_tests.program",
      "content_view_tests.programDisplayName",
      "content_view_tests.nodeNames",
      "content_view_tests.averageTimeSpent"
    ],
    measures: [
      // "content_view_tests.assignedPercent",
      // "content_view_tests.completedPercent",
      "content_view_tests.avgScore"
    ]
  },
  requestFilterMap: {
    "tests.program": "content_view_tests.program",
    "content.skill": "content_view_tests.skillsTreeIds",
    "content.standard": "content_view_tests.standardsFilter"
  },
  searchRequestParams: ["content_view_tests.name"],
  requestDefaultOrder: { "content_view_tests.id": "asc" },
  tableOptions: {
    searchPlaceholder: "Content",
    selectable: false,
    caption: "List of Practice Test items"
  },
  alertPageTitle: "Content"
}

export const CONTENT_LIBRARY_MASTERY_LESSON: TableData = {
  // Dynamic columns are generated in helpers/tables.ts
  columns: [
    {
      label: "Name",
      name: "content_view_ml_lessons.name",
      sortable: true,
      description: "content_view_ml_lessons.description"
    },
    {
      label: "Test",
      name: "content_view_ml_lessons.test",
      sortable: true
    },
    {
      label: "Standard",
      name: "content_view_ml_lessons.standards",
      sortable: true,
      formatter: reportingCategoriesAndStandardsFormatter
    },
    {
      label: "Reporting Category",
      name: "content_view_ml_lessons.nodeNames",
      sortable: true,
      formatter: reportingCategoriesAndStandardsFormatter
    },
    {
      label: "Duration",
      name: "content_view_ml_lessons.duration",
      sortable: true,
      type: "duration",
      align: "right"
    }
    // {
    //   label: "% Assigned",
    //   name: "content_view_ml_lessons.assignedPercent",
    //   sortable: true,
    //   type: "percent",
    //   align: "right"
    // },
    // {
    //   label: "% Complete",
    //   name: "content_view_ml_lessons.completedPercent",
    //   sortable: true,
    //   type: "percent",
    //   align: "right"
    // },
    /*
    {
      label: "Average Time Spent",
      name: "content_view_ml_lessons.averageTimeSpent",
      sortable: true,
      formatter: formatMilliseconds,
      type: "duration",
      align: "right"
    },
    {
      label: "Average Accuracy",
      name: "content_view_ml_lessons.accuracy",
      sortable: true,
      type: "percent",
      formatter: (record, prop) =>
        Number(record["content_view_ml_lessons.attempts"])
          ? Math.round(record[prop])
          : "--",
      align: "right"
    }
    */
  ],
  displayedProperties: [
    "content_view_ml_lessons.name",
    "content_view_ml_lessons.programDisplayName",
    "content_view_ml_lessons.test",
    "content_view_ml_lessons.subject",
    "content_view_ml_lessons.nodeNames",
    "content_view_ml_lessons.standards",
    "content_view_ml_lessons.standardsFilter",
    "content_view_ml_lessons.standardTreeNames",
    "content_view_ml_lessons.duration",
    "content_view_ml_lessons.description",
    "content_view_ml_lessons.averageTimeSpent",
    "content_view_ml_lessons.accuracy",
    "content_view_ml_lessons.attempts"
    // "content_view_ml_lessons.assignedPercent",
    // "content_view_ml_lessons.completedPercent"
  ],
  requestParams: {
    dimensions: [
      "content_view_ml_lessons.id",
      "content_view_ml_lessons.name",
      "content_view_ml_lessons.programDisplayName",
      "content_view_ml_lessons.test",
      "content_view_ml_lessons.nodeNames",
      "content_view_ml_lessons.standards",
      "content_view_ml_lessons.standardsFilter",
      "content_view_ml_lessons.standardTreeNames",
      "content_view_ml_lessons.subject",
      "content_view_ml_lessons.duration",
      "content_view_ml_lessons.description",
      "content_view_ml_lessons.averageTimeSpent"
    ],
    measures: [
      "content_view_ml_lessons.accuracy",
      "content_view_ml_lessons.attempts"
      // "content_view_ml_lessons.assignedPercent",
      // "content_view_ml_lessons.completedPercent"
    ]
  },
  requestFilterMap: {
    "tests.program": "content_view_ml_lessons.program",
    "tests.subject": "content_view_ml_lessons.subject",
    "content.skill": "content_view_ml_lessons.skillsTreeIds",
    "content.standard": "content_view_ml_lessons.standardsFilter"
  },
  searchRequestParams: ["content_view_ml_lessons.name"],
  requestDefaultOrder: { "content_view_ml_lessons.id": "asc" },
  tableOptions: {
    searchPlaceholder: "Content",
    selectable: false,
    caption: "List of Online Lesson items"
  },
  alertPageTitle: "Content"
}

export const CONTENT_LIBRARY_MASTERY_CURRICULUM: TableData = {
  columns: [
    {
      label: "Name",
      name: "content_view_mc_lessons.name",
      sortable: true,
      description: "content_view_mc_lessons.description"
    },
    {
      label: "Test",
      name: "content_view_mc_lessons.test",
      sortable: true
    },
    {
      label: "Reporting Category",
      name: "content_view_mc_lessons.nodeNames",
      sortable: true,
      formatter: reportingCategoriesAndStandardsFormatter
    },
    {
      label: "Skills",
      name: "shownSkills",
      sortable: false,
      formatter: shownSkillsFormatter("remainingSkills")
    },
    {
      label: "Duration",
      name: "content_view_mc_lessons.duration",
      sortable: true,
      type: "duration",
      align: "right"
    }
    // {
    //   label: "% Assigned",
    //   name: "content_view_mc_lessons.assignedPercent",
    //   sortable: true,
    //   type: "percent",
    //   align: "right"
    // },
    // {
    //   label: "% Complete",
    //   name: "content_view_mc_lessons.completedPercent",
    //   sortable: true,
    //   type: "percent",
    //   align: "right"
    // },
    /*
    {
      label: "Average Time Spent",
      name: "content_view_mc_lessons.averageTimeSpent",
      sortable: true,
      type: "duration",
      formatter: formatMilliseconds,
      align: "right"
    },
    {
      label: "Average Accuracy",
      name: "content_view_mc_lessons.accuracy",
      sortable: true,
      type: "percent",
      formatter: (record, prop) =>
        Number(record["content_view_mc_lessons.attempts"])
          ? Math.round(record[prop])
          : "--",
      align: "right"
    }
    */
  ],
  displayedProperties: [
    "content_view_mc_lessons.name",
    "content_view_mc_lessons.description",
    "content_view_mc_lessons.programDisplayName",
    "content_view_mc_lessons.test",
    "content_view_mc_lessons.subject",
    "content_view_mc_lessons.nodeNames",
    "shownSkills",
    "content_view_mc_lessons.duration",
    "content_view_mc_lessons.averageTimeSpent",
    // "content_view_mc_lessons.assignedPercent",
    // "content_view_mc_lessons.completedPercent",
    "content_view_mc_lessons.accuracy",
    "content_view_mc_lessons.attempts"
  ],
  requestParams: {
    dimensions: [
      "content_view_mc_lessons.id",
      "content_view_mc_lessons.name",
      "content_view_mc_lessons.description",
      "content_view_mc_lessons.programDisplayName",
      "content_view_mc_lessons.test",
      "content_view_mc_lessons.subject",
      "content_view_mc_lessons.nodeNames",
      "content_view_mc_lessons.duration",
      "content_view_mc_lessons.averageTimeSpent"
    ],
    measures: [
      // "content_view_mc_lessons.assignedPercent",
      // "content_view_mc_lessons.completedPercent",
      "content_view_mc_lessons.accuracy",
      "content_view_mc_lessons.attempts"
    ]
  },
  requestFilterMap: {
    "tests.program": "content_view_mc_lessons.program",
    "tests.subject": "content_view_mc_lessons.subject",
    "content.standard": "content_view_mc_lessons.standardsFilter"
  },
  searchRequestParams: ["content_view_mc_lessons.name"],
  requestDefaultOrder: { "content_view_mc_lessons.id": "asc" },
  tableOptions: {
    searchPlaceholder: "Content",
    selectable: false,
    caption: "List of Book Chapter items"
  },
  alertPageTitle: "Content"
}
